<template>
    <div>
        <dashboard-section-title>{{ $t('Upcoming quests') }}</dashboard-section-title>

        <template v-if="quests && quests.length">
            <template v-for="(quest, index) in questCards">
                <quest-card
                    :key="`upcomming-quest-${quest.startDate.date}${quest.id}${index}`"
                    :quest="quest"
                    :label="$t('Active')"
                    :quest-participants-label="$t('Volunteers')"
                    :hide-participants-info="quest.pointsApplyStrategy == 'scan'"
                    color="secondary"
                    class="mb-5"
                />
            </template>
        </template>

        <v-card flat v-else>
            <v-skeleton-loader type="article" />
        </v-card>
    </div>
</template>

<script>
import QuestCard from './QuestCard';
import { mapState } from 'vuex';
import {ActivityModel} from '../models';
import moment from 'moment';

const MAX_CARDS = 3;

export default {
    components: {
        QuestCard,
    },
    props: {
        quests: Array,
    },
    computed: {
        ...mapState('organization', ['selectedOrganizationID']),
        questCards() {
            const questCards = [];
            if (this.quests) {
                this.quests.some(quest => {
                    if (!quest.activityDates.length) {
                        questCards.push({
                            ...quest,
                            participantsCount: ActivityModel.countParticipants(quest),
                        });

                        return questCards.length === MAX_CARDS;
                    } else {
                        return quest.activityDates.some(activityDate => {
                            if (activityDate.isActive) {
                                let startTime = activityDate.startTime.split(':');
                                let endTime = activityDate.endTime.split(':');
                                
                                questCards.push({
                                    ...quest,
                                    startDate: {
                                        date: moment(activityDate.date.date).hour(startTime[0]).minute(startTime[1]),
                                    },
                                    endDate: {
                                        date: moment(activityDate.date.date).hour(endTime[0]).minute(endTime[1]),
                                    },
                                    participantsCount: ActivityModel.countParticipants(quest, activityDate),
                                });
                            }

                            return questCards.length === MAX_CARDS;
                        });
                    }
                });
            }
            return questCards;
        },
    },
};
</script>
